import React from "react";
import ReactDOMClient from "react-dom/client";
import "../../utils/i18next";
import "../../utils/debug";
import { TermsOfUsePage } from "./TermsOfUsePage";

const app = document.getElementById("root");
const root = ReactDOMClient.createRoot(app);

root.render(<TermsOfUsePage />);
